import { useEffect, useState } from 'react';
import './goto.css'; 
const Goto=()=>{
    const [isvisible,setisvisible]=useState(false)
    const goToBtn=()=>{
        window.scroll({top:0,left:0,behavior:"smooth"});
    }
    const listenToScroll=()=>{
        let heightToHidden=1000;
        const WinScroll=document.body.scrollTop || document.documentElement.scrollTop;
        if(WinScroll>heightToHidden){
            setisvisible(true)
        }else{
            setisvisible(false)
        }
    }
    useEffect(()=>{
        window.addEventListener("scroll",listenToScroll)
        return ()=>window.removeEventListener("scroll",listenToScroll);
    },[]);
    return(
        <>  {isvisible && (
               <div className="top-btn" onClick={goToBtn}>
                <i className="fa fa-solid fa-circle-arrow-up float-end text-primary top-btn--icon"></i>
            </div>
        )}
        </>
    )
}
export default Goto;